module.exports = __webpack_public_path__ + "static/media/dolce.943ac1d6.jpg";